module.exports = __webpack_public_path__ + "img/gsport.23aca58.webp";